const readStats = async (): Promise<Datapoint[]> => {
    const url = process.env.REACT_APP_FUNCTIONS_BASE_URL
    if (!url) {
        console.error('REACT_APP_FUNCTIONS_URL is not set')
        return []
    }

    try {
        const response = await fetch(url + '/read_progress', {
            method: 'GET',
        })
        const data = await response.json()

        return data.result.map((row: {updated_at: string, chapter_id: number, progress: number}) => ({
            updatedAt: row.updated_at,
            chapterId: row.chapter_id,
            progress: row.progress,
        }))
    } catch (error) {
        console.error('error', error)
        return []
    }
}


type Datapoint = {
    updatedAt: string
    chapterId: number
    progress: number
}

export { readStats, type Datapoint }